import { LoaderFunctionArgs } from "react-router-dom";
import { store } from "../../store";
import { getAllPrivacyPolicy } from "../../actions/privacy-policy";
import { resetPrivacyPolicy } from "../reducers/privacy-policy.reducer";

export const privacyPolicyLoader = async (args: LoaderFunctionArgs) => {
  store.dispatch(resetPrivacyPolicy());

  return await getAllPrivacyPolicy();
};
